import React from 'react';

import { Text } from '@change/ds-core-ui/Text';
import { MessagesCommunicationsIllustration } from '@change/ds-illustrations/MessagesCommunicationsIllustration';

type Props = {
	message: string;
	callToActionSlot?: React.JSX.Element;
};

export const EmptyStateCtaPanel: React.FC<Props> = ({ message, callToActionSlot }) => {
	return (
		<div className="elevation-low dark:border-stroke-weaker flex max-w-[628px] shrink-0 flex-col items-center justify-center gap-4 rounded-lg p-6 text-center dark:border">
			<MessagesCommunicationsIllustration alt="" loading="lazy" className="h-[104px] w-[114px] object-cover" />
			<Text size="large">{message}</Text>
			{callToActionSlot}
		</div>
	);
};
